<template>
	<transition name="fade" mode="out-in" appear>
		<router-view :keep-alive="true"></router-view>
	</transition>
</template>

<script>
    export default {
        name: "manager",
		props:{
            productSlug: String,
            productType: String,
		},
		created(){

            this.$store.dispatch('setProductType', this.productType);

			this.$store.dispatch('getProduct', this.productSlug);
			this.$store.dispatch('getPackagingFee');
			this.$store.dispatch('getEnergyFee');
			this.$store.dispatch('getDeliveryZipCodes');

            if(this.$route.path === '/' && this.productType === 'App\\Product')
            {
                return;
            }
			this.$router.replace({
                name: this.productType === 'App\\Product' ? 'product':'custom.product',
            }).catch(()=>{

            })
		}
    }
</script>
